import type { MaterialKey } from '../world/Level';

/** Render-only finishes. Excluded from simulation and replay fingerprints. */
export const SURFACE_FINISH: Partial<Record<MaterialKey, {
  specular: number;
  shininess: number;
  bumpScale?: number;
}>> = {
  wood: { specular: 0x111111, shininess: 8, bumpScale: 0.018 },
  fence: { specular: 0x111111, shininess: 8, bumpScale: 0.018 },
  pirttiWall: { specular: 0x16130f, shininess: 10, bumpScale: 0.015 },
  faluRed: { specular: 0x161310, shininess: 10, bumpScale: 0.015 },
  tub: { specular: 0x454038, shininess: 35, bumpScale: 0.018 },
  pirttiRoof: { specular: 0x292929, shininess: 26, bumpScale: 0.012 },
  barnRoof: { specular: 0x292929, shininess: 26, bumpScale: 0.012 },
  lanRoof: { specular: 0x292929, shininess: 26, bumpScale: 0.012 },
  metal: { specular: 0x444950, shininess: 45 },
  car: { specular: 0x66717c, shininess: 65 },
  carAlt: { specular: 0x635951, shininess: 50 },
  carEv: { specular: 0x87939b, shininess: 85 },
  carGlass: { specular: 0x9faebd, shininess: 100 },
  water: { specular: 0x91b7c9, shininess: 90, bumpScale: 0.008 },
};
